import React from "react";
import { Box, Heading, Badge, Spacer } from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";
import { translation } from "../../utils/translation";

export const Review = (props) => {
  return (
    <Box
      mt={5}
      p={[4, 5]}
      borderWidth="1px"
      borderRadius="lg"
      borderColor="#c3c3c3"
      overflow="hidden"
    >
      <Box>
        <Box d="flex">
          <Box>
            <Heading as="h3" size="md">
              {props.author}
            </Heading>

            <Box display={"flex"} alignItems={"center"} gap={1}>
              {Array(5)
                .fill("")
                .map((_, i) => (
                  <StarIcon
                    key={i}
                    w={5}
                    height={5}
                    color={i < props.score ? "#ff8f00" : "gray.300"}
                  />
                ))}
            </Box>
          </Box>
          <Spacer />
          <Box>
            <Box>
              {translation("general.review.date").replace("{date}", props.date)}

              <br />
              <Badge colorScheme="green">
                {translation("general.review.verifiedPurchase")}
              </Badge>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box mt={5} pt={5} borderTopWidth="1px" borderColor="#c3c3c3">
        <p>{props.review}</p>
      </Box>
    </Box>
  );
};
